import { render, staticRenderFns } from "./RmpEmptyLayout.vue?vue&type=template&id=3a9263b2&scoped=true"
import script from "./RmpEmptyLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./RmpEmptyLayout.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9263b2",
  null
  
)

export default component.exports